var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-loading"},[_c('v-overlay',{attrs:{"value":_vm.OverlayLoadingFlag}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }